import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { pharmacyService } from '../services/pharmacyService';

export const getPharmacyById = createAsyncThunk(
  'pharmacy/getPharmacyById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await pharmacyService.getPharmacyById(id);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const pharmacySlice = createSlice({
  name: 'pharmacy',
  initialState: {
    pharmacy: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPharmacyById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPharmacyById.fulfilled, (state, action) => {
        state.loading = false;
        state.pharmacy = action.payload;
      })
      .addCase(getPharmacyById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = pharmacySlice.actions;

export default pharmacySlice.reducer;
